import { useContext, useState } from 'react';
import styled from 'styled-components';
import { LayoutContext } from '../context/LayoutContext';
import { ThemeColors } from '../theme';
import { TextCSS } from './Text';
import { Context } from './Context';
import { MapImg } from './MapImg';

const MapWrapper = styled.button<{
  $color: ThemeColors | undefined;
  $locked: boolean;
}>`
  position: relative;
  display: flex;
  gap: ${(props) => `1.5${props.theme.unit}`};
  flex-direction: row;
  width: ${(props) => `30${props.theme.unit}`};
  padding: ${(props) => `1.5${props.theme.unit}`};
  border: 0.5vmin solid #000;
  background: ${(props) =>
    props.$color ? props.theme.color[props.$color] : 'rgba(0, 0, 0, 0.6)'};
  border-radius: 1vmin;
  box-shadow: ${(props) => `0 0.5${props.theme.unit} 0 rgba(0, 0, 0, 0.3)`};
  align-items: center;
  cursor: pointer;
  line-height: 1.5;
`;
const MapName = styled.div`
  ${TextCSS({})}
  color: ${(props) => props.theme.color.white};
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;
const Mode = styled.img`
  width: ${(props) => `4${props.theme.unit}`};
  height: ${(props) => `4${props.theme.unit}`};
`;
const MapInfo = styled.img`
  position: absolute;
  top: ${(props) => `-1${props.theme.unit}`};
  right: ${(props) => `-1${props.theme.unit}`};
  width: ${(props) => `3${props.theme.unit}`};
  height: ${(props) => `3${props.theme.unit}`};
`;

export const MatchMap = ({
  id,
  locked,
  onClick,
}: {
  id: number | null;
  locked?: number | null | undefined;
  onClick: () => void;
}) => {
  const { maps } = useContext(LayoutContext);
  const [show, setShow] = useState<boolean>(false);

  const map = maps.find((m) => m.id === id);
  if (id && !map) return <>{id}</>;

  return (
    <>
      <MapWrapper
        onClick={() => {
          if (locked) {
            if (map) setShow(true);
            return;
          }
          onClick();
        }}
        $color={map?.mode}
        $locked={!!locked}
      >
        {map && (
          <>
            <Mode
              src={`${process.env.PUBLIC_URL}/images/game-modes/${map.mode}.webp`}
              alt=""
            />
            <MapName>{map.name}</MapName>
            <MapInfo
              src={`${process.env.PUBLIC_URL}/images/info.webp`}
              alt=""
            />
          </>
        )}
      </MapWrapper>
      {show && !!map && (
        <Context
          onClose={() => {
            setShow(false);
          }}
        >
          <MapImg map={map} selected={false} />
        </Context>
      )}
    </>
  );
};
